import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProvider } from "@/redux/baseQuery";
import { OnboardingStatusRawResponse, SectionStatusRaw, UpdateSectionRequest } from "./types";
import { OnboardingStatus, SectionStatus } from "@/redux/slices/onboarding/types";
import { transformOnboardingStatus, transformSectionStatus } from "./helpers";

export const onboardingApi = createApi({
  reducerPath: "onboardingApi",
  baseQuery: baseQueryWithProvider(),
  endpoints: (builder) => ({
    getOnboardingStatus: builder.query<OnboardingStatus, void>({
      query: () => "onboarding-status",
      transformResponse: (response: OnboardingStatusRawResponse) => transformOnboardingStatus(response),
      providesTags: ["OnboardingStatus"],
    }),
    updateSectionStatus: builder.mutation<SectionStatus, UpdateSectionRequest>({
      query: (body) => ({
        url: "onboarding-status",
        method: "PATCH",
        body,
      }),
      transformResponse: (response: SectionStatusRaw) => transformSectionStatus(response),
      invalidatesTags: ["OnboardingStatus"],
    }),
  }),
  tagTypes: ["OnboardingStatus"],
});

export const {
  useGetOnboardingStatusQuery,
  useLazyGetOnboardingStatusQuery,
  useUpdateSectionStatusMutation,
} = onboardingApi;